import { render, staticRenderFns } from "./BModalPartners.vue?vue&type=template&id=20303c1a&scoped=true"
import script from "./BModalPartners.vue?vue&type=script&lang=js"
export * from "./BModalPartners.vue?vue&type=script&lang=js"
import style0 from "./BModalPartners.vue?vue&type=style&index=0&id=20303c1a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20303c1a",
  null
  
)

export default component.exports